import { Facebook, Twitter, Linkedin, Link as LinkIcon } from 'lucide-react';
import { useState } from 'react';

interface ShareButtonsProps {
  title: string;
  url: string;
}

export function ShareButtons({ title, url }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(url);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const baseButtonClass =
    "flex items-center gap-2 px-4 py-2 rounded-full text-sm transition border border-yellow-500 text-yellow-100 hover:bg-yellow-500/10";

  return (
    <div className="flex gap-4 flex-wrap transition-transform duration-300 hover:scale-105">
      <a
        href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={baseButtonClass}
      >
        <Twitter className="w-4 h-4" />
        Twitter
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={baseButtonClass}
      >
        <Facebook className="w-4 h-4" />
        Facebook
      </a>
      <a
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        className={baseButtonClass}
      >
        <Linkedin className="w-4 h-4" />
        LinkedIn
      </a>
      <button
        onClick={handleCopy}
        className={baseButtonClass}
      >
        <LinkIcon className="w-4 h-4" />
        {copied ? 'Copied!' : 'Copy Link'}
      </button>
    </div>
  );
}
